module.exports = __webpack_public_path__ + "img/main_ylw.79833de6.jpg";